/**
 * Coercions shared by the widgets' legacy → v0 migrations. Legacy widget JSON was
 * written by FormGroup panels that did not type-check what they stored, so a value
 * is parsed rather than trusted; `undefined` means "unreadable — use the seed".
 */

/** A number, including one persisted as a string (`'50'`). */
export const parseNumber = (value: unknown): number | undefined => {
    if (value === null || value === undefined || value === '') return undefined;
    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : undefined;
};

export const oneOf = <T extends string>(values: readonly T[], value: unknown): T | undefined =>
    values.includes(value as T) ? (value as T) : undefined;

export const stringOrUndefined = (value: unknown): string | undefined =>
    typeof value === 'string' ? value : undefined;

/** `{ desktop }`, plus a `mobile` leaf only where the persisted mobile bag actually carried the key. */
export const responsiveValue = <T>(desktop: T, mobile: T | undefined): { desktop: T; mobile?: T } =>
    mobile === undefined ? { desktop } : { desktop, mobile };

/**
 * The legacy envelope's root `createdAt` (ms since the epoch). Widgets created before the
 * field existed have none: unknown, `null` — never a guessed "now".
 */
export const createdAtOrNull = (value: unknown): number | null =>
    typeof value === 'number' && Number.isInteger(value) && value >= 0 ? value : null;
